module.exports = __webpack_public_path__ + "tenis.png?6dcb98888ffc96b9ba83d49d0f0920cc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tenis.png
// module id = 691
// module chunks = 0 2 7 8 9 10